/**
 * Streaming section: YouTube, VK, Telegram URLs.
 */

import { type ReactNode } from "react";
import { InlineLinkField } from "../InlineFields.tsx";
import { SmartSection } from "../SmartSection.tsx";

export interface StreamingSectionProps {
  id: string;
  streamYoutubeUrl: string;
  setStreamYoutubeUrl: (v: string) => void;
  streamVkUrl: string;
  setStreamVkUrl: (v: string) => void;
  telegramChatUrl: string;
  setTelegramChatUrl: (v: string) => void;
  icon: ReactNode;
  summary: string;
  filledCount: number;
  totalCount: number;
  hint?: string;
}

export function StreamingSection({
  id,
  streamYoutubeUrl,
  setStreamYoutubeUrl,
  streamVkUrl,
  setStreamVkUrl,
  telegramChatUrl,
  setTelegramChatUrl,
  icon,
  summary,
  filledCount,
  totalCount,
  hint,
}: StreamingSectionProps) {
  return (
    <SmartSection
      id={id}
      title="Трансляции"
      icon={icon}
      summary={summary}
      filledCount={filledCount}
      totalCount={totalCount}
      hint={hint}
      defaultOpen={false}
    >
      <div className="card overflow-hidden">
        <InlineLinkField
          label="YouTube"
          hint="Трансляция"
          value={streamYoutubeUrl}
          onChange={setStreamYoutubeUrl}
          placeholder="https://youtube.com/..."
        />
        <InlineLinkField
          label="VK"
          hint="Трансляция"
          value={streamVkUrl}
          onChange={setStreamVkUrl}
          placeholder="https://vk.com/video..."
        />
        <InlineLinkField
          label="Telegram"
          hint="Чат мероприятия"
          value={telegramChatUrl}
          onChange={setTelegramChatUrl}
          placeholder="https://t.me/..."
        />
      </div>
    </SmartSection>
  );
}
